import { BaseService } from "../BaseService";
import { EventStatusBaseService } from "./EventStatusBaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { EventStatusModel } from "../../models/api/EventStatusModel";
import { EventStatusFindResultModel } from "../../models/api/EventStatusFindResultModel";

@Injectable({
    providedIn: 'root'
})

export class EventStatusService extends EventStatusBaseService {

    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
    };

}
